import { SplashLetters } from "./SplashLetters";
import { SplashFireworks, SplashJets, SplashLights, SplashParticles } from "./SplashEffects";

/** The full splash scene. Fills the viewport, or its parent box when `contained` (admin preview). */
export const SplashStage = ({ theme, contained = false, leaving = false, testId, children }) => (
  <div className={`splash-root splash-stage ${contained ? "splash-stage-contained" : "splash-stage-full"} ${theme.art ? "is-cinematic" : ""} ${leaving ? "splash-out" : ""}`}
    style={{ "--splash-glow": theme.glow }} data-splash-theme={theme.id} data-testid={testId}>
    {theme.art && <img src={theme.art} alt="" draggable="false" className="splash-art" data-testid={`${testId}-art`} />}
    {theme.art && <div className="splash-veil" aria-hidden="true" />}
    {theme.art && <div className="splash-rays" aria-hidden="true" />}
    <div className="splash-stars" aria-hidden="true" />
    {theme.extras === "fireworks" && <SplashFireworks />}
    <SplashParticles theme={theme} layer="back" />
    <div className="splash-content" data-testid={`seasonal-splash-${theme.id}`}>
      <SplashLetters theme={theme} />
      <SplashJets theme={theme} />
    </div>
    <div className="splash-rule" aria-hidden="true" />
    <div className="splash-copy" data-testid={`${testId}-copy`}>
      <p className="splash-tagline splash-motto" data-testid={`${testId}-motto`}>{theme.motto}</p>
      <p className="splash-tagline splash-sub" data-testid={`${testId}-subline`}>{theme.subline}</p>
    </div>
    <SplashParticles theme={theme} layer="front" />
    {theme.extras === "lights" && <SplashLights />}
    {theme.art && <div className="splash-letterbox" aria-hidden="true" />}
    {children}
  </div>
);
